<div class="col-md-12 mb-5">

    <div *ngIf='(viewState$ | async) as d'>
        <div class="card card-cascade narrower">
            <mdb-card>
                <mdb-body>
                    <div
                        class="view view-cascade gradient-card-header blue-gradient narrower py-1 mx-4 mb-3 justify-content-between align-items-center">
                        <div class="row">
                        <div class="col-md-4 last-update-date">{{d.LastUpdated}}</div>
                        <div class="col-md-4 mx-auto board-name">{{d.detail.SkillsetName}}</div>
                        <div class="col-md-4 mx-auto"></div>
                    </div>
                    </div>
                    <div class="card-body card-body-cascade">
                        <div class="table-responsive">
                            <table class="table" mdbTable small="true" hover="true">
                                <tbody>
                                    <tr>
                                        <td class="column-title">Alert Start</td>
                                        <td class="column-data">{{d.detail.BeginTime}}</td>
                                        <td class="column-title">Alert End</td>
                                        <td class="column-data">{{d.detail.EndTime}}</td>
                                    </tr>
                                    <tr>
                                        <td class="column-title">Calls Waiting</td>
                                        <td class="column-data">{{d.detail.CallsWaiting}}</td>
                                        <td class="column-title">Max Wait Time</td>
                                        <td class="column-data">{{d.detail.MaxWaitTime}}</td>
                                    </tr>
                                    <tr>
                                        <td class="column-title">Agents In Service</td>
                                        <td class="column-data">{{d.detail.AgentsInService}}</td>
                                        <td class="column-title">Agents Available</td>
                                        <td class="column-data">{{d.detail.AgentsAvailable}}</td>
                                    </tr>
                                    <tr>
                                        <td class="column-title">Agents Not Ready</td>
                                        <td class="column-data">{{d.detail.AgentsNotReady}}</td>
                                        <td class="column-title">Agents On Call</td>
                                        <td class="column-data">{{d.detail.AgentsOnCall}}</td>
                                    </tr>
                                    <tr>
                                        <td class="column-title">Agents On DnCall</td>
                                        <td class="column-data">{{d.detail.AgentsOnDnCall}}</td>
                                        <td class="column-title">Agents On Other Skill Call</td>
                                        <td class="column-data">{{d.detail.AgentsOnOtherSkillCall}}</td>
                                    </tr>
                                    <tr>
                                        <td class="column-title">Answered After Threshold</td>
                                        <td class="column-data">{{d.detail.CallsAnsweredAfterThreshold}}</td>
                                        <td class="column-title"></td>
                                        <td class="column-data"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mdb-body>
            </mdb-card>
        </div>
    </div>
</div>